import { Component, OnDestroy, OnInit } from '@angular/core';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { SnackNotifier } from '@app/shared/notifier/snack-notifier';
import { Navigate } from '@ngxs/router-plugin';
import { AuthActions } from '@app/modules/auth/store/auth.actions';
import { IPasswordRestoreConfirm } from '@app/modules/auth/interface/password-restore-confirm';
import { QueryString } from '@app/shared/helpers/query-string';
import {IPasswordReset} from "@app/modules/auth/interface/password-reset";

@Component({ templateUrl: './password-restore.component.html' })
export class PasswordRestorePageComponent implements OnInit, OnDestroy {
  public username = QueryString.find('username');
  private _subscription = new Subscription();

  /**
   * @param store
   * @param actions
   * @param snack
   */
  constructor(
    private readonly store: Store,
    private readonly actions: Actions,
    private readonly snack: SnackNotifier,
  ) {}

  public ngOnInit(): void {
    this.subscribeOnPasswordRestoreConfirmSuccess();
    this.subscribeOnPasswordRestoreConfirmFailed();
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public confirm(value: IPasswordReset): void {
    this.store.dispatch(new AuthActions.PasswordReset(value));
  }

  private subscribeOnPasswordRestoreConfirmSuccess(): void {
    this._subscription.add(
      this.actions
        .pipe(ofActionDispatched(AuthActions.PasswordResetSuccess))
        .subscribe(() => {
          this.snack.success('New password successfully confirmed!');
          this.store.dispatch(new Navigate(['/auth/login']));
        }),
    );
  }

  private subscribeOnPasswordRestoreConfirmFailed(): void {
    this._subscription.add(
      this.actions
        .pipe(ofActionDispatched(AuthActions.PasswordResetFailure))
        .subscribe(({ error }) =>
        {
          this.snack.error(error);
          //console.log("ERRRRRRRRRRRRRRRRRR",error);
          //this.store.dispatch(new Navigate(['/auth/login']));
        }
        ),
    );
  }
}
